export default {
  routes: [
    {
      name: 'backgroundTasks',
      path: '/background-tasks',
      component: () => import('./views/TheBackgroundTasks.vue'),

    },

    {
      name: 'backgroundTask',
      path: '/background-tasks/:id',
      component: () => import('./views/TheBackgroundTask.vue'),
    },
  ]
}
